import { Injectable } from "@angular/core";
import { AngularFireDatabase } from '@angular/fire/database';
import { BehaviorSubject, Subject, Observable, Subscription } from 'rxjs';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import { authenticationService } from '../Authentication/authentication.service';
import { isUndefined } from 'util';
import { FactoryService } from "../historique/factory.service";



@Injectable({
  providedIn: 'root'
})


export class CotationVoyageService  {

 subscrip: Subscription
 uploadState=new BehaviorSubject<boolean>(false);
 primeBaseAnnuelle=new BehaviorSubject<any[]>([]);
 ListAccessoire = new BehaviorSubject<any[]>([]);
 PrimeTTC=new BehaviorSubject<any>(null);
 task:AngularFireUploadTask

 constructor(private db: AngularFireDatabase,
    private storage: AngularFireStorage,private _fact:FactoryService,
    private authentic: authenticationService) {

          this.getaccessoires();

  }
  calculPrime(myDateDep,myDateFin,nbjr,age,zone){
   
    let value={
      periode:"",
      rub:"VOYAGE",
      prime:0,
      acc:0,
      Taxe:0,
      dateEff:myDateDep.split('T')[0],
      dateEx:myDateFin.split('T')[0],
      duree:nbjr,
      Ttc:0,
      open:false,
      type:"VOYAGE"
    }
      
    this.TarifVoyage("",zone,nbjr,this.queue(age))
    this.primeBaseAnnuelle
    .subscribe(
      (result) =>{
        if (result.length>0) {
        let _o=result.find(e => e.P_Min<=nbjr && e.P_Max>=nbjr)
        if (!isUndefined(_o)) {
          value.prime=_o.Prime
          value= this.calculAccessoire(value)
          this.PrimeTTC.next(this.calculPrimeTTC(value,8))
        }else{
          
          this.PrimeTTC.next(null)
        }
          
        }
       
      }
    )
     // return value
    
    }

    private queue(age){
      let val=""
      if (age <= 18) {
        val="018"
      }else if( age > 18 && age <= 80){
        val="1980"
      }
     
      return val
    }

 calculAccessoire(_objetNette:any):any{
  _objetNette.acc=0;
  let myacc=1500
  this.ListAccessoire.subscribe((access) => {
    _objetNette.acc= (_objetNette.prime !=0) ? access.filter(a => a.min <= _objetNette.prime && a.max >= _objetNette.prime)[0].acc+myacc:0
       })
return _objetNette
}
 calculPrimeTTC(_objetNette:any,tauxTaxe:number):any{
  
    //#region TAXE ENREGISTREMENT
        _objetNette.Taxe=Math.round((_objetNette.prime+_objetNette.acc)*tauxTaxe/100)
        
    //#endregion
    //#region TAXE CSS
        _objetNette.css=Math.round((_objetNette.prime+_objetNette.acc)/100)
       
    //#endregion
    _objetNette.Ttc=_objetNette.prime + _objetNette.acc + _objetNette.css + _objetNette.Taxe
    

  return _objetNette
}
private getaccessoires() {
  //+this.codeAssur
  this.db.list("Accessoires/1010", ref => ref.orderByValue()).snapshotChanges(['child_added']).subscribe(
    (actions) => {
      const ListAccessoire = [];
      actions.forEach((action) => {
        ListAccessoire.push({
          acc: action.payload.exportVal().acc,
          min: action.payload.exportVal().min,
          max: action.payload.exportVal().max
        });
      })
      this.ListAccessoire.next(ListAccessoire)
      //return ListAssreurs
    }
  )
}
 
  
async TarifVoyage(codeAss,zone,nbjr,age){
  // this.loading2 = await this.loadingController.create({
  //   message: 'Envoi en cours...',
  //   // duration: 2000,
  //   spinner: 'bubbles'
  // });

  // await this.loading2.present();
  codeAss=this._fact.getData(201)
  await this.db.list(`TarifVoyage/${codeAss}/${zone}/${age}`)
   .snapshotChanges().subscribe(
     (actions) => {
       const result = [];
       actions.forEach((action) => {
           result.push({
             Prime:action.payload.exportVal().Prime_nette,
             P_Min:action.payload.exportVal().P_Min,
             P_Max:action.payload.exportVal().P_Max
           });
       })    
 
      
       this.primeBaseAnnuelle.next(result)
      
     }
   )
 }
  // VOYAGE
   async instNewVoyage(voyage: any,codeAssur,$key:string) {
    voyage.CodeAssur=codeAssur
    voyage.Quittance=$key
    voyage.type="Voyage"
    return await this.db.list(`Cotations/${this.authentic.profile.uid}/Voyage`).push(voyage)
  }
 
 async uploadFile(filepass: string,repertoire: string,voyage:any=null) {
     var filePath = `${repertoire}/${new Date().getTime()}.jpeg`;
     const fileRef = this.storage.ref(filePath)
  return await fileRef.putString(filepass,'data_url') //, 'data_url'
   
}



  
}



